export interface PaymentLinkFee {
  cdTipoTransacao: number;
  cdTipoTaxa: number;
  nuParcelas: number;
  vlFator: number;
  txCET?: number;
}

// As formas disponíveis vêm da tabela do link, com taxa do portador (3).
export const simulatePaymentLink = (amount: number, fees: PaymentLinkFee[]) => {
  if (!Number.isFinite(amount) || amount <= 0) return [];

  const pixLimit = fees.find((fee) => Number(fee.cdTipoTaxa) === 39);

  return fees
    .filter(
      (fee) =>
        Number(fee.cdTipoTransacao) === 3 &&
        [1, 2, 3].includes(Number(fee.cdTipoTaxa)) &&
        Number.isInteger(Number(fee.nuParcelas)) &&
        Number(fee.nuParcelas) > 0 &&
        Number.isFinite(Number(fee.vlFator)) &&
        Number(fee.vlFator) > 0
    )
    .map((fee) => {
      const isPix = Number(fee.cdTipoTaxa) === 3;
      const isDebit = Number(fee.cdTipoTaxa) === 1;
      const installments = Number(fee.nuParcelas);
      let installmentAmount = Number(fee.vlFator) * amount;
      let totalAmount = installmentAmount * installments;

      if (isPix && pixLimit) {
        const minimum = Number(pixLimit.vlFator);
        const maximum = Number(pixLimit.txCET);
        if (Number.isFinite(minimum)) {
          totalAmount = Math.max(totalAmount, amount + minimum);
        }
        if (Number.isFinite(maximum)) {
          totalAmount = Math.min(totalAmount, amount + maximum);
        }
        installmentAmount = totalAmount;
      }

      return {
        type: isPix ? 'Pix' : isDebit ? 'Débito' : 'Crédito',
        installments: isPix || isDebit ? 'Única' : `${installments}x`,
        installmentAmount,
        totalAmount,
      };
    });
};
